import React from "react"
import TargetPreciselyImage from "../../../../../components/staticQuery/platform/automation/TargetPreciselyImage"
import FlexibleDatesImage from "../../../../../components/staticQuery/platform/offers/FlexibleDatesImage"
import P from "../../../../../components/typography/P"
import CalendarGraphic from "../../../../../images/platform/offers/calendar-icon.svg"

const DescriptionText = () => (
  <>
    <P>
      Choose from a variety of options for every situation. Offers are typically
      used to capture new leads, entice people to come back to your business and
      reward loyal customers.
    </P>
    <P>
      But why give a discount to a lead today when they are already making a
      purchase? Instead, choose tomorrow as the effective date for your Offer to
      tempt them to come back.
    </P>
  </>
)

const flexibleDatesData = {
  titleIcon: CalendarGraphic,
  title: "Flexible Effective Dates",
  description: <DescriptionText />,
  graphic: <FlexibleDatesImage />,
  // imageLeft: false,
  textLong: false,
  benefits: [
    {
      benefitName: "Custom effective dates",
    },
    {
      benefitName: "Valid on birth day, week or month",
    },
    { benefitName: "Limit by day and time" },
    { benefitName: "Choose the number of redemptions allowed" },
  ],
}

export default flexibleDatesData
